// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2NL_j","item":"PaymentsMobile_item__3H8Yd","label":"PaymentsMobile_label__24u_5","amount":"PaymentsMobile_amount__6feTe"};